<div class="post-new-car">

  <h1>Poster mon véhicule</h1>

  <form #newCarForm="ngForm" class="new-car-form">

    <mat-form-field >
      <mat-label>Marque</mat-label>
      <mat-select  required name = "make" (selectionChange)="onMakeChange($event.value)" >
        @for (make of (makes$ | async)!; track make; let i = $index) {
          <mat-option [value]="make" >{{make.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>


    <mat-form-field>
      <mat-label>Modèle</mat-label>
      <mat-select required name = "model" (selectionChange)="onModelChange($event.value)" >
        @for (model of (models$ | async)!; track model) {
          <mat-option [value]="model" >{{model.makeName}} {{model.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field >
      <mat-label>Version</mat-label>
      <mat-select matNativeControl required name = "version" (selectionChange)="onVersionChange($event.value)">
        @for (version of (versions$ | async)!; track version) {
          <mat-option [value]="version" >{{version.makeName}} {{version.modelName}} {{version.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field >
      <mat-label>Motorisation</mat-label>
      <mat-select matNativeControl required name = "engine" (selectionChange)="onEngineChange($event.value)">
        @for (engine of selectedVersion.engines; track engine) {
          <mat-option [value]="engine" >{{engine.id}} {{engine.code}} {{engine.name}}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field >
      <mat-label>Année</mat-label>
      <mat-select matNativeControl required name = "year" [(ngModel)]="car.year">
        @for (year of carYears; track year) {
          <mat-option [value]="year"> {{year}} </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div>
      @if (car.version != '') {
        <span>
          <label id="example-radio-group-label">Boite</label>
          <br />
          <mat-radio-group
            aria-labelledby="example-radio-group-label" class="example-radio-group" name="gearbox" [(ngModel)]="car.gearBox">
            @for (g of carGearBoxes; track g; let i = $index) {
              <mat-radio-button class="example-radio-button"  [value]="g">
                {{g}}
              </mat-radio-button>
            }
          </mat-radio-group>
        </span>
      }
    </div>

    <div>
      @if (car.version != '') {
        <span>
          <label id="example-radio-group-label">Carburant</label>
          <br />
          <mat-radio-group
            aria-labelledby="example-radio-group-label" class="example-radio-group" name="fuel" [(ngModel)]="car.fuel">
            @for (f of carFuelTypes; track f; let i = $index) {
              <mat-radio-button class="example-radio-button"  [value]="f">
                {{f}}
              </mat-radio-button>
            }
          </mat-radio-group>
        </span>
      }
    </div>

    <mat-form-field>
      <mat-label>Kilometrage</mat-label>
      <input required matNativeControl type="number" matInput="" step="1000" name ="mileage" placeholder="Km"  [(ngModel)] = "car.mileage" >
    </mat-form-field>

    <p style="color: orange">{{ formMessage }} </p>

  </form>

  <div class="buttons">
    <!-- <button mat-button class="simple-button"  (click)="clearForm()"> <mat-icon>cancel</mat-icon>Annuler</button> -->
    <button type="submit" matButton mat-button class="cta-button" [disabled] = "newCarForm.value.version =='' || newCarForm.value.mileage < 1 "  (click)="submitForm()"> <mat-icon>save</mat-icon>Poster</button>
  </div>

</div>
